import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';

const agentService = {
  async fetchAgentList(): Promise<AgentT[]> {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.get(`/workspaces/${wa}/managers`);
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async fetchAgent(alias: string): Promise<AgentT> {
    try {
      const res = await defaultAxios.get(`/managers/${alias}`);
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async createAgent(params: PostAgentParams): Promise<AgentT> {
    try {
      const wa = getCurrWorkspaceAlias();
      const res = await defaultAxios.post(`/workspaces/${wa}/manager`, {
        ...params,
      });
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async deleteAgent(alias: string): Promise<boolean> {
    try {
      const res = await defaultAxios.delete(`/managers/${alias}`);
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async updateAgentAttr<K extends keyof AgentT>(
    alias: string,
    target: K,
    value: AgentT[K],
  ) {
    try {
      const res = await defaultAxios.patch(`/managers/${alias}/${target}`, {
        [target]: value,
      });
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  async updateAgentTags(alias: string, tags: string[]) {
    try {
      const res = await defaultAxios.patch(`/managers/${alias}/tags`, {
        tags,
      });
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};

export default agentService;
